'use client';

import { DashboardType } from '@/config/dashboardWorkflows';
import CustomerDashboard from './CustomerDashboard';
import ErrorBoundary from './ErrorBoundary';
import FinancesDashboard from './FinancesDashboard';
import GTMDashboard from './GTMDashboard';
import ProductTimelineDashboard from './ProductTimelineDashboard';

interface DashboardViewProps {
  dashboardType: DashboardType;
}

export default function DashboardView({ dashboardType }: DashboardViewProps) {
  const dashboardComponents: Record<DashboardType, { component: React.ComponentType; title: string }> = {
    gtm: { component: GTMDashboard, title: 'GTM Dashboard' },
    customer: { component: CustomerDashboard, title: 'Customer Dashboard' },
    finances: { component: FinancesDashboard, title: 'Finances Dashboard' },
    product: { component: ProductTimelineDashboard, title: 'Product Timeline' },
  };

  const config = dashboardComponents[dashboardType];
  if (!config) return null;

  const DashboardComponent = config.component;

  return (
    <ErrorBoundary fallbackTitle={`${config.title} encountered an error`}>
      <DashboardComponent />
    </ErrorBoundary>
  );
}
